export enum ProductType {
    Free = 0,
    Families = 1,
    Teams = 2,
    Enterprise = 3,
}
